var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { differenceBy, keys } from 'lodash';
export var NoVisibibleSearchTerms = ['keyType', 'extra', 'sort_by', 'showHalfTime'];
export var DefaultSuggestions = [
    {
        name: 'bpm:',
        prepFilter: function (value) {
            var bpm = value.substr(4).trim();
            if (!Number.isNaN(parseInt(bpm))) {
                return { bpm_min: bpm, bpm_max: bpm };
            }
            return undefined;
        }
    },
    {
        name: 'bpm_max:',
        prepFilter: function (value) {
            var bpm = value.substr(8).trim();
            if (!Number.isNaN(parseInt(bpm))) {
                return { bpm_max: bpm };
            }
            return undefined;
        },
        display: 'BPM Max:'
    },
    {
        name: 'bpm_min:',
        prepFilter: function (value) {
            var bpm = value.substr(8).trim();
            if (!Number.isNaN(parseInt(bpm))) {
                return { bpm_min: bpm };
            }
            return undefined;
        },
        display: 'BPM Min:'
    },
    {
        name: 'key:',
        prepFilter: function (value) {
            var key = value.substr(4).trim();
            if (key) {
                if (key.length == 1) {
                    key = key.toUpperCase();
                }
                return { key: key };
            }
            return undefined;
        }
    },
    {
        name: 'loops',
        prepFilter: function (value, other) {
            return { tags: other.tags ? other.tags.concat('loop') : ['loop'] };
        }
    },
    {
        name: 'one-shots',
        prepFilter: function (value, other) {
            return { tags: other.tags ? other.tags.concat('one-shot') : ['one-shot'] };
        }
    },
    {
        name: 'tags:',
        prepFilter: function (value, other) {
            var tag = value.substr(5).trim();
            if (tag) {
                return { tags: other.tags ? other.tags.concat(tag) : [tag] };
            }
            return undefined;
        },
        display: 'Tag:'
    },
    {
        name: 'tag_groups:',
        prepFilter: function (value, other) {
            var tag = value.substr('tag_groups:'.length).trim();
            if (tag) {
                return { tag_groups: other.tag_groups ? other.tag_groups.concat(tag) : [tag] };
            }
            return undefined;
        },
        display: 'Tag Group:'
    },
    {
        name: 'subgenre:',
        prepFilter: function (value, other) {
            var tag = value.substr(9).trim();
            if (tag) {
                return { subgenre: other.subgenre ? other.subgenre.concat(tag) : [tag] };
            }
            return undefined;
        }
    },
    {
        name: 'genre:',
        prepFilter: function (value) {
            var tag = value.substr(6).trim();
            if (tag) {
                return { genre: tag };
            }
            return undefined;
        }
    },
];
export var SoundListTags = DefaultSuggestions.slice();
SoundListTags.push({
    name: 'search:',
    prepFilter: function (value) {
        var tag = value.substr(7).trim();
        if (tag) {
            return { search: tag };
        }
    }
});
export var buildFilterFromArray = function (search, prevFilter) {
    var searchTerm = '';
    var filter = {};
    search.forEach(function (s) {
        var _a;
        var f = DefaultSuggestions.find(function (suggestions) { return s.toLowerCase().startsWith(suggestions.name); });
        if (f) {
            filter = __assign(__assign({}, filter), f.prepFilter(s, filter));
        }
        else {
            if (s.includes(':') && prevFilter && prevFilter[s.split(':')[0]]) {
                filter = __assign(__assign({}, filter), (_a = {}, _a[s.split(':')[0]] = prevFilter[s.split(':')[0]], _a));
            }
            else
                searchTerm += ' ' + s;
        }
    });
    filter.search = searchTerm;
    if (prevFilter) {
        filter = Object.assign({}, filter, differenceBy(keys(prevFilter), keys(filter).concat(NoVisibibleSearchTerms)).reduce(function (prev, key) {
            prev[key] = undefined;
            return prev;
        }, {}));
    }
    return filter;
};
export var onTagClick = function (tag, filter, setFilter) {
    var currentTags = __spreadArrays(filter.tags || []);
    if (currentTags.includes(tag.id) || currentTags.includesLowercase(tag.name)) {
        currentTags = currentTags.filter(function (t) { return !(t == tag.id || t.toLowerCase() == tag.name.toLowerCase()); });
    }
    else {
        currentTags.push(tag.name);
    }
    setFilter(function (filter) {
        return __assign(__assign({}, filter), { tags: currentTags });
    });
};
//# sourceMappingURL=search.js.map